import { createSlice } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

// Slice
const labPanelsSlice = createSlice({
  name: 'labPanels',
  initialState: initialStore.labPanels,
  reducers: {
    getLabPanels: (state, { payload }) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setLabPanels: (state, { payload }) => {
      state.isLoading = false;
      state.labPanels = payload;
    },
    failAction: (state) => {
      state.isLoading = false;
    }
  }
});

export const { getLabPanels, setLabPanels, failAction } =
  labPanelsSlice.actions;

export const { reducer } = labPanelsSlice;

// Selectors
export const getLabPanelsSelector = (state: IState) =>
  state && state.labPanels.labPanels;
